/*
  时间过滤
*/
export function timeFilter(time) {

    if (!time) return ''

    let type

    if (Object.keys(time).length) {
        type = time.type
        time = time.time
    } else {
        time = new Date(time)
    }

    let year = time.getFullYear()
    let month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1
    let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()

    let hours = time.getHours() < 10 ? "0" + (time.getHours()) : time.getHours()
    let minutes = time.getMinutes() < 10 ? "0" + (time.getMinutes()) : time.getMinutes()
    let seconds = time.getSeconds() < 10 ? "0" + (time.getSeconds()) : time.getSeconds()

    if (type == 1) {
        return `${year}-${month}-${day}`
    } else {

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

}

/* 
  变时间戳
*/
export function toTimestamp(time) {

    let d = new Date(time)

    return d.getTime() / 1000

}

export function nowTime() {
    let time = new Date()

    let year = time.getFullYear()
    let month = (time.getMonth() + 1) < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1
    let day = time.getDate() < 10 ? "0" + time.getDate() : time.getDate()
    let hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
    let minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()
    let seconds = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds()

    return `${year}-${month}-${day} ${hours}时${minutes}分${seconds}秒`
}

/* 
  虚拟数据时间修改
  
  axisName - 时间轴名称
  axisType - 时间格式: 1: yyyy-mm-dd | 0: yyyy-mm-dd hh:mm:ss
  reverse - 是否反转: true | false
  type - 数据格式: 见代码
  data - 数据
  
*/
export function transformAxisData(o) {

    let { axisName = 'axisData', axisType = 1, reverse = true, type = 1, data, d } = o

    d = deepCopy(data)

    if (type == 1) {
        /*
          data =  {
            axisData: [],
            dataList: []
          }  
        */
        d[axisName] = data[axisName].map((t, i) => timeFilter({ time: new Date(new Date() - i * 24 * 3600 * 1000), type: axisType }))

        if (reverse) d[axisName].reverse()

    } else if (type == 2) {
        /*
          data = [
            { name: '2021-06-11, value: 0 }
          ]
        */

        d.map((t, i) => {

            t[axisName] = timeFilter({ time: new Date(new Date() - i * 24 * 3600 * 1000), type: axisType })

        })

        if (reverse) d.reverse()

    }

    return d
}

/* 
  随机数
*/

export let randomNum = (start = 0, end, accuracy = 0) => {

    if (!start && start !== 0) start = 10

    // 如果只填了一个数值, 从 0 到当前数值
    if (!end && end !== 0) {
        end = start
        start = 0
    }

    let num = (Math.random() * (end - start) + start).toFixed(accuracy)

    return num
}


/* 
  判断数据类型 
  
  data: any - 数据 - 返回数据类型  *首字母大写* 

  type: String - 则返回data数据类型与type的比较 - true | false
        Array -  则满足其中一项判断返回 true, 全不满足返回 false 
                       
*/

export let nicTypeOf = (data, type) => {

    let s = Object.prototype.toString.call(data).split(' ')[1]  // [Object xxx]

    let dataType = s.substr(0, s.length - 1)

    if (type) {

        if (Array.isArray(type)) {

            let r = type.some(t => t === dataType)

            return r
        }

        return dataType === type
    }

    return dataType
}

/**
 * 深度拷贝
 * @param obj
 * @returns {*}
 */
export function deepCopy(obj) {
    let result = Array.isArray(obj) ? [] : {};
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object' && obj[key] != null) {  // typeof null 也会是object, 需要特别判断
                result[key] = deepCopy(obj[key]);   //递归复制
            } else {
                result[key] = obj[key];
            }
        }
    }
    return result;
}

/**
 * 矩形边界检测-碰撞检测法
 * 两个矩形中心点在x方向的距离的绝对值小于等于矩形宽度和的二分之一，同时y方向的距离的绝对值小于等于矩形高度和的二分之一
 * @param {*} frameRect 
 * @param {*} itemRect 
 */
export function checkByRectCollisionDetection(frameRect, itemRect) {
    var x1 = frameRect.x + frameRect.w / 2,
        y1 = frameRect.y + frameRect.h / 2,
        w1 = frameRect.w,
        h1 = frameRect.h;
    var x2 = itemRect.x + itemRect.w / 2,
        y2 = itemRect.y + itemRect.h / 2,
        w2 = itemRect.w,
        h2 = itemRect.h;
    if (Math.abs(x1 - x2) < ((w1 + w2) / 2) && Math.abs(y1 - y2) < ((h1 + h2) / 2))
        return true;
    else
        return false;
}

/**
 * 计算两线段之间的夹角 ( 同一个中心点 )
 * 
 * @param {*}  // {开始坐标x - 中心点坐标x, 开始坐标y - 中心点坐标y}
 * @param {*}  // {结束坐标x - 中心点坐标x, 结束坐标y - 中心点坐标y}
 */

export function getAngle({ x: x1, y: y1 }, { x: x2, y: y2 }) {
    const dot = x1 * x2 + y1 * y2
    const det = x1 * y2 - y1 * x2
    const angle = Math.atan2(det, dot) / Math.PI * 180
    return Math.round(angle + 360) % 360
}

/* position封装 */
export let setPosition = (item) => {
    let {
        cplaceX: x,
        cplaceY: y,
        careaLength: h,
        careaWidth: w,
    } = item

    return { x, y, h, w }
}


/* 
  递归
  查询offsetParent
  返回当前元件的页面位置
  { top, left }
*/
export function offsetParent(target, o) {
    if (!target.tagName) return
    let { top, left, parentFlag } = o || {}
    let { offsetTop, offsetLeft } = target
    let p = target.offsetParent

    if (p) {
        parentFlag = true;
        ({ top, left } = offsetParent(p, { parentFlag }))
        top += offsetTop
        left += offsetLeft
    } else {
        top = 0
        left = 0
    }
    return {
        top,
        left
    }
}

/* 
  递归
  根据className查询指定offsetParent
  指定上层第一个匹配到className的节点(node)
*/
export function findParentNode(target, className) {

    let p = target.parentNode
    let { classList } = p
    let res = Array.from(classList).some(t => t == className)

    if (!res) p = findParentNode(p, className)

    return p
}


/* 
  读取文件
  直接读取前端upload中的文件, <input type="file" />
*/
export function readerFile(params) {
    let reader = new FileReader()

    reader.readAsText(params.file)

    reader.onload = () => {
        console.log(reader.result)   // reader.result为获取结果
    }
}

/* 千分符 正则 */
export function thousands(num) {
    var str = num.toString();
    var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
    return str.replace(reg, "$1,");
}